var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center my-5"},[_vm._v(" validating... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }